import { z } from 'zod';
export const healthResponse = z.object({
    status: z.enum(['ok', 'degraded']),
    db: z.enum(['ok', 'fail']),
    version: z.string(),
    uptime_s: z.number(),
});
//# sourceMappingURL=health.js.map